export default class Glossary {

    constructor() {
        this.bindUIActions();
    }

    bindUIActions() {

        if ($('.js-glossary-item') != null) {

            let $glossaryLetter = $('.js-glossary-letter');
            let $glossaryItem = $('.js-glossary-item');
            let $glossaryItemsArray = $glossaryItem.toArray();
            let $glossaryContent = $('.js-glossary-content');

            // Show the matching description when clicking an expression in the glossary
            $glossaryItem.on( 'click', function() {
                // The data-glossary-item attribute holds a unique value for each expression
                let id = $(this).data('glossary-item');
                // Hide all glossary descriptions
                $glossaryContent.addClass('hidden');
                // Remove the active class from all the glossary items
                $glossaryItem.removeClass('active');
                // Add the active class to the clicked expression
                $(this).addClass('active');
                // Remove the hidden class from the matching description (the data-glossary-content attribute holds the same value as its matching expression/glossary item)
                $('div[data-glossary-content='+id+']').removeClass('hidden');
            });

            // Clicking a letter which will highlight the first expression starting with that letter
            $glossaryLetter.on( 'click', function() {

                // The data-glossary-letter attributes hold the letter values from a-z
                let letter = $(this).data('glossary-letter');
                // This will serve as a break statement
                let breakOut = false;

                // Loop through all of the glossary items, aka expressions
                $glossaryItemsArray.forEach(($item) => {

                    // The data-glossary-item attribute holds a unique name for each expression
                    let expression = $item.getAttribute('data-glossary-item');

                    // If the current expression in the loop starts with the clicked letter,
                    // then we will highlight the first instance of the glossary items starting with the given letter
                    if(expression.substring(0,1) === letter && breakOut === false){

                        // Hide all descriptions
                        $glossaryContent.addClass('hidden');
                        // Remove the active class from all glossary items
                        $glossaryItem.removeClass('active');

                        // Find the element which holds the given expression as its data-glossary-item value and highlight it through adding the 'active' class to it
                        $('h3[data-glossary-item='+expression+']').addClass('active');
                        // Find and show the matching description by removing the 'hidden' class from the element
                        $('div[data-glossary-content='+expression+']').removeClass('hidden');

                        // On small screens smooth scroll to the active element
                        if($(window).width() < 1024) {
                            $('html, body').animate({
                                scrollTop: $('.js-glossary-item-small.active').offset().top - 50
                            }, 2000);
                        }

                        // Break the loop after the first match, so we won't highlight all of the expressions starting with the clicked letter, only the first one
                        breakOut = true;
                    }

                });
            });

        }

    }
};

new Glossary();